module.exports = __webpack_public_path__ + "static/media/product-list-small-placeholder.2bbf20aa.webp";